import { Reveal } from "./Reveal";
import { Check, ArrowRight } from "lucide-react";

const EMPLOYER = [
  "Define manpower requirements",
  "Candidate sourcing",
  "CV screening",
  "Experience verification",
  "Interview coordination",
  "Candidate shortlisting",
  "Documentation support",
  "Work-permit / immigration coordination",
  "Pre-departure support",
];

const CANDIDATE = [
  "Verified job opportunities",
  "Transparent job information",
  "Employer information",
  "Recruitment process guidance",
  "Documentation assistance",
  "Work-permit guidance",
  "Pre-departure assistance",
];

const Column = ({ tag, title, items, cta, href, delay }) => (
  <Reveal delay={delay}>
    <div className="h-full border border-[#e4e4e7] p-8 md:p-12 flex flex-col">
      <p className="font-body text-xs tracking-[0.25em] uppercase text-[#ff3b30] mb-4">{tag}</p>
      <h3 className="font-head uppercase tracking-tight text-3xl md:text-5xl mb-8">{title}</h3>
      <ul className="space-y-3 mb-10">
        {items.map((it) => (
          <li key={it} className="flex items-start gap-3 font-body text-[#52525b]">
            <Check size={18} className="text-[#ff3b30] shrink-0 mt-0.5" strokeWidth={2.5} />
            {it}
          </li>
        ))}
      </ul>
      <a
        href={href}
        data-testid={`audience-cta-${tag.toLowerCase()}`}
        className="group mt-auto inline-flex items-center gap-3 bg-[#0a0a0a] hover:bg-[#ff3b30] text-white font-head uppercase text-sm tracking-wide px-6 py-4 w-max transition-colors duration-300"
      >
        {cta}
        <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
      </a>
    </div>
  </Reveal>
);

export const Audiences = () => (
  <section id="for-employers" data-testid="audiences-section" className="py-24 md:py-32 px-6 md:px-12">
    <div className="max-w-[1600px] mx-auto">
      <Reveal>
        <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-6">
          Built for both sides
        </p>
        <h2 className="font-head uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl xl:text-8xl mb-16 md:mb-20">
          Employers &amp;
          <br />
          candidates.
        </h2>
      </Reveal>
      <div id="for-candidates" className="grid grid-cols-1 lg:grid-cols-2 gap-6 scroll-mt-24">
        <Column tag="Employers" title="For Employers" items={EMPLOYER} cta="Post a job" href="/employers" delay={0} />
        <Column tag="Candidates" title="For Candidates" items={CANDIDATE} cta="View jobs & apply" href="/candidates" delay={0.1} />
      </div>
    </div>
  </section>
);
